import { render, staticRenderFns } from "./SubEmpresaBlocoDadosVisualizarContratoOriginacao.vue?vue&type=template&id=2a0c81b4&scoped=true&lang=pug"
import script from "./SubEmpresaBlocoDadosVisualizarContratoOriginacao.vue?vue&type=script&lang=js"
export * from "./SubEmpresaBlocoDadosVisualizarContratoOriginacao.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaBlocoDadosVisualizarContratoOriginacao.vue?vue&type=style&index=0&id=2a0c81b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0c81b4",
  null
  
)

export default component.exports